/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: block;
  cursor: pointer;
  padding: calc(9rem/14) calc(14rem/14);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #FFF;
  background-color: var(--davinci-color-background, #FFF);
}

:host(:hover),
:host(.selected) {
  background-color: #e5f1f8;
  background-color: var(--davinci-color-information-primary-light, #e5f1f8);
}

:host([disabled]) ::slotted(*),
:host([disabled]) {
  pointer-events: none;
  cursor: default;
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}

:host,
* {
  box-sizing: border-box;
}`;
export { style };
//# sourceMappingURL=Option.style.js.map